import React from 'react';
import useAppFeature from '../../app/useAppFeature';
import { AppFeatureEnum } from '../../enums/appFeatureEnum';
import { RoleTypeEnum } from '../../enums/roleTypeEnum';
import { useAuthStore } from '../../context/AuthContext';
import useAiChat from './useAiChat';
import AiChatDrawer from './AiChatDrawer';
import { FloatingButton, FloatingButtonIcon } from './AiChat.styles';

/** Users with early access to AI Chat Agent regardless of AppFeature flag */
const EARLY_ACCESS_USERS = ['kristoffer.ramstad@odfjell.com'];

const AiChat: React.FC = () => {
    const { isFeatureEnabled } = useAppFeature();
    const { loggedInUser, role } = useAuthStore();
    const chat = useAiChat();

    const featureEnabledByApi = isFeatureEnabled({
        featureEnum: AppFeatureEnum.AiChatAgent,
        disableWhenOffline: true,
    });

    const isAdmin = role?.roleType === RoleTypeEnum.Admin;
    const isEarlyAccessUser = EARLY_ACCESS_USERS.includes(loggedInUser?.userName?.toLowerCase() ?? '');
    const featureEnabled = featureEnabledByApi || isAdmin || isEarlyAccessUser;

    if (!featureEnabled) return null;

    return (
        <>
            {!chat.isOpen && (
                <FloatingButton onClick={chat.open} title="Open AI Assistant" aria-label="Open AI Assistant">
                    <FloatingButtonIcon>💬</FloatingButtonIcon>
                </FloatingButton>
            )}

            {chat.isOpen && (
                <AiChatDrawer
                    messages={chat.messages}
                    isLoading={chat.isLoading}
                    suggestions={chat.suggestions}
                    onSend={chat.sendMessage}
                    onStop={chat.stopGenerating}
                    onClear={chat.clearMessages}
                    onClose={chat.close}
                />
            )}
        </>
    );
};

export default AiChat;
